(() => {
  if (window.acNextCartMounted) return;
  window.acNextCartMounted = true;
  const experimentId = '0f92c098-7b05-4301-a33d-8c559e577c13';
  const groups = {
    'cbe1a5a4-e153-4065-a0bf-c713ac4a06c8': 'control',
    'ac1003f9-db25-422d-8388-4ba81f6e5083': 'lower',
    'ef4b4d8e-1290-46b7-9c91-fa776f2a7ce5': 'higher'
  };
  let state = 'pending';
  let variant = 'control';
  let assignmentStatus = 'pending';
  let scheduled = false;
  let retryTimer;
  let deadlineTimer;
  function stopRetry() {
    clearInterval(retryTimer);
    clearTimeout(deadlineTimer);
  }
  function report(status) {
    if (window.acNextCartStatus === status) return;
    window.acNextCartStatus = status;
    window.dispatchEvent(new CustomEvent('ac:cart-test-status', {detail: {experimentId, status}}));
  }
  function readAssignment() {
    const user = window.igData?.user;
    if (typeof user?.getTestGroup !== 'function') return false;
    let group;
    try { group = user.getTestGroup(experimentId); }
    catch (error) { return false; }
    if (group && !groups[group.id]) return false;
    variant = group ? groups[group.id] : 'control';
    state = 'ready';
    window.acNextCartVariant = variant;
    stopRetry();
    assignmentStatus = group ? 'assigned-' + variant : 'not-assigned';
    report(assignmentStatus);
    schedule();
    return true;
  }
  function refreshSliders(target) {
    requestAnimationFrame(() => {
      if (!target.isConnected) return;
      target.querySelectorAll('splide-component').forEach(slider => slider.acSlider?.refresh());
    });
  }
  function mount() {
    scheduled = false;
    let missingTemplate = false;
    let mountedSlot = false;
    document.querySelectorAll('[data-ac-cart-test-slot]').forEach(slot => {
      const previous = slot.dataset.acAssignment;
      slot.dataset.acAssignment = state;
      if (state !== 'ready') return;
      const target = slot.querySelector('[data-ac-cart-mount]');
      if (!target) return;
      if (slot.dataset.acMounted !== variant) {
        const source = slot.querySelector(`template[data-ac-cart-template="${variant}"]`);
        if (!source) {
          slot.dataset.acAssignment = 'unavailable';
          missingTemplate = true;
          return;
        }
        target.replaceChildren(source.content.cloneNode(true));
        slot.dataset.acMounted = variant;
        refreshSliders(target);
      } else if (previous !== 'ready') refreshSliders(target);
      mountedSlot = true;
    });
    if (state === 'ready') {
      if (missingTemplate) report('missing-template');
      else if (mountedSlot) report(assignmentStatus);
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(mount);
  }
  function waitForAssignment() {
    if (readAssignment()) return;
    stopRetry();
    state = 'pending';
    window.acNextCartVariant = undefined;
    report('pending');
    schedule();
    retryTimer = setInterval(readAssignment, 250);
    deadlineTimer = setTimeout(() => {
      stopRetry();
      if (readAssignment()) return;
      state = 'ready';
      window.acNextCartVariant = variant;
      assignmentStatus = 'fallback-' + variant;
      report(assignmentStatus);
      schedule();
    }, 3000);
  }
  window.addEventListener('ig:ready', waitForAssignment);
  window.addEventListener('ac:cart-test-assignment', waitForAssignment);
  window.addEventListener('pageshow', event => { if (event.persisted) waitForAssignment(); });
  waitForAssignment();
  function start() {
    new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
    mount();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();